var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 84.113 84.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warn",
    transform: "translate(0 0.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M84.113,42.056A42.051,42.051,0,0,1,42.332,84.11c-.028,0-.058,0-.085,0-.062,0-.126,0-.191,0a42.056,42.056,0,0,1-29.737-71.8A41.781,41.781,0,0,1,42.056,0c.064,0,.126,0,.191,0h.089A42.052,42.052,0,0,1,84.113,42.056Zm0,0",
    transform: "translate(0 -0.027)",
    fill: "#f36b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M257.183,107.8C257.252,107.8,257.123,107.8,257.183,107.8Zm0,0",
    transform: "translate(-214.919 -90.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M257.178,307.563C257.119,307.563,257.238,307.564,257.178,307.563Zm0,0",
    transform: "translate(-214.914 -257.038)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167",
    transform: "translate(37.021 18.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M224.829,114.809v18.8c0,3.865-2.292,7.008-5.109,7.008h-.013a4.8,4.8,0,0,1-3.6-2.052,8.452,8.452,0,0,1-1.5-4.957v-18.8c0-3.822,2.313-6.9,5.1-7.008h.013c2.817,0,5.109,3.144,5.109,7.008Zm0,0",
    transform: "translate(-214.61 -107.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M227.11,326.379a5.115,5.115,0,0,1-5.11,5.11h-.013a5.11,5.11,0,0,1,0-10.219H222A5.115,5.115,0,0,1,227.11,326.379Zm0,0",
    transform: "translate(-216.891 -284.302)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.1ee4a57302da59144399662e2267e294.svg";
export { ForwardRef as ReactComponent };